module.exports = __webpack_public_path__ + "static/media/logoCemmob.2abf947a.svg";